import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => (
  <g>
    <rect
      x="2.5"
      y="4.16602"
      width="15"
      height="11.6667"
      rx="1"
      stroke={fill}
      strokeWidth="1.5"
    />
    <path d="M3 8L17 8" strokeWidth="1.5" strokeLinecap="round" stroke={fill} />
    <path d="M3 9L17 9" strokeWidth="1.5" strokeLinecap="round" stroke={fill} />
    <path
      d="M5 13L9 13"
      strokeWidth="1.5"
      strokeLinecap="round"
      stroke={fill}
    />
  </g>
);

export default Icon;
